import {combineReducers, configureStore} from '@reduxjs/toolkit';

import userReducer from './slices/userSlice.js';
import clientsReducer from './slices/clientsSlice.js';
import usersReducer from './slices/usersSlice.js';
import jobsReducer from './slices/jobsSlice.js';
import themeReducer from './slices/themeSlice.js';
import notificationsReducer from './slices/notificationsSlice.js';
import alertsReducer from './slices/alertsSlice.js';
import accountingCountsReducer from './slices/accountingCountsSlice.js';
import buildRefreshReducer from './slices/buildRefreshSlice.js';
import tenantReducer from './slices/tenantSlice.js';
// import projectReducer from './slices/projectSlice';
// import filtersReducer from './slices/filtersSlice';

const rootReducer = combineReducers({
  user: userReducer,
  clients: clientsReducer,
  users: usersReducer,
  jobs: jobsReducer,
  theme: themeReducer,
  notifications: notificationsReducer,
  alerts: alertsReducer,
  accountingCounts: accountingCountsReducer,
  buildRefresh: buildRefreshReducer,
  tenant: tenantReducer,
  // project: projectReducer,
  // filters: filtersReducer,
});

export const store = configureStore({
  reducer: rootReducer,
});
